module.exports = __webpack_public_path__ + "static/img/toll-free.d9ec524d.svg";